import FlipInfoIcon from './FlipInfoIcon'
import { PLACEHOLDER } from './format'
import { STRIP_PADDING_CLS } from './MetricCard'

// Tooltip copy: node 8763:2480, "METRICS" block, first entry (27.09 export, SOW 3 spec 6) -- the
// other five live in MetricsStrip.jsx, this component's own sibling, not its parent (spec 4.6).
const DEAL_SCORE_TOOLTIP =
  'A composite score based on projected profitability, costs, timeline, and risk. Higher scores indicate stronger deals.\n\n[65–69: Near your maximum allowable offer (MAO)\n70–79: Worth considering\n80+: Great deal]'

// The one place the 0-100 scale lives -- see README.md ("Deal Score is 0-100, not the backend's
// 0-10", "dealScoreBand is a total function") for why the scale is not converted here and why the
// chain is `<` on each band's lower edge rather than `<=` on its upper one.
export function dealScoreBand(score) {
  if (!Number.isFinite(score)) return null
  if (score < 61) return '#B53642'
  if (score < 65) return '#A94708'
  if (score < 70) return '#8A6800'
  if (score < 80) return '#477D32'
  return '#1F7A2E'
}

const UNAVAILABLE_BG = '#566451'

// 140x88, rx 8 (spec 4.1/4.2) -- a sibling of the metrics container built in MetricsStrip.jsx,
// never its sixth card (spec 4.6, and see MetricsStrip.jsx's own header comment).
export default function DealScoreBlock({ score }) {
  // Round once, reuse the rounded value for both the band lookup and the display -- otherwise a
  // raw score like 79.6 takes the 70-79 band's colour while showing "80", which reads as 80-100.
  const rounded = Number.isFinite(score) ? Math.round(score) : null
  const band = dealScoreBand(rounded)
  const unavailable = band == null
  // Value stays 36px in both states, including the em dash -- README.md ("Deal Score value size")
  // records why the swatch board's own 32px for that glyph does not override spec 4.3's resolution.
  const displayValue = unavailable ? PLACEHOLDER : rounded

  return (
    <div
      className={`relative w-[140px] h-[88px] rounded-[8px] flex flex-col items-center shrink-0 ${STRIP_PADDING_CLS}`}
      style={{ backgroundColor: unavailable ? UNAVAILABLE_BG : band }}
    >
      {/* Label row centred horizontally as a unit (spec 4.1); vertically it sits 14px from the top
          border, like the metric cards (letter 99, 7.4.1, MetricCard.jsx STRIP_PADDING_CLS). */}
      <span className="inline-flex items-center gap-x-[6px]">
        <span className="text-[14px] leading-[1.2] font-bold text-white">{unavailable ? 'Unavailable' : 'Deal Score'}</span>
        {/* hoverStroke repeats `stroke`: the shared #328C12 hover measures 1.15-1.47:1 against all six band fills
            (README.md, "Info-icon hover"), so it never replaces the resting white here. `floating`:
            the strip's overflow row clips an absolute panel below 1280. */}
        <FlipInfoIcon tooltip={DEAL_SCORE_TOOLTIP} stroke="#FFFFFF" hoverStroke="#FFFFFF" floating />
      </span>
      <span className="text-[36px] leading-[1.2] font-extrabold text-white">{displayValue}</span>
    </div>
  )
}
